module.exports = __webpack_public_path__ + "static/perfilDraFernandaTrevilin-f12cb88e734e53df1f756379db5b2e19.svg";